import { Frame } from '@/marketing/Frame';
import { Reveal } from '@/lib/motion';

export function Mission() {
  return (
    <Frame id="mission" label="Our mission">
      <Reveal>
        <h2 className="max-w-4xl font-display text-[clamp(2.4rem,6vw,4.5rem)] font-bold leading-[1.02] tracking-[-0.03em] text-foreground">
          Democratize{' '}
          <span className="relative whitespace-nowrap">
            wealth management
            <span className="absolute -bottom-1 left-0 h-[3px] w-full bg-[image:linear-gradient(90deg,var(--nq-blue-bright),var(--nq-gold))]" />
          </span>
          .
        </h2>
      </Reveal>

      <div className="mt-12 grid gap-10 border-t border-white/8 pt-10 md:grid-cols-[1.1fr_1fr]">
        <Reveal delay={0.05}>
          <p className="text-xl leading-relaxed text-foreground/90">
            For decades, the best investment engines — daily quantitative
            research, machine-learning models, institutional risk management —
            were locked behind hedge-fund minimums and closed doors.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="text-lg leading-relaxed text-muted-foreground">
            NovaQuantis exists to open that door. We put the whole engine inside a
            single ETF — the same strategy and the same execution for every
            investor — so disciplined, AI-driven investing is available to anyone
            with a brokerage account. Not the few. Everyone.
          </p>
        </Reveal>
      </div>
    </Frame>
  );
}
